export const AppCat = 'delivery';